"use client";

import {
    ThemeProvider as NextThemesProvider,
    useTheme as useNextTheme,
} from "next-themes";
import { ThemeProviderProps } from "next-themes";
import { useIsClient } from "@/hooks/use-is-client";
import { useEffect } from "react";

function ThemeSyncer() {
    const { theme, systemTheme } = useNextTheme();
    useEffect(() => {
        const activeTheme = theme === "system" ? systemTheme : theme;
        if (typeof document !== "undefined") {
            document.documentElement.setAttribute(
                "data-theme",
                activeTheme || "light"
            );
            document.body.setAttribute("data-bs-theme", activeTheme || "light");
        }
    }, [theme, systemTheme]);
    return null;
}

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
    const isClient = useIsClient();

    if (!isClient) {
        return null;
    }

    return (
        <NextThemesProvider
            attribute="data-theme"
            defaultTheme="system"
            enableSystem
            {...props}
        >
            <ThemeSyncer />
            {children}
        </NextThemesProvider>
    );
}

// Re-export useTheme from next-themes
export { useNextTheme as useTheme };
